<script setup lang="ts">
import Wrapper from '../ui/wrapper/Wrapper.vue';
import Content from '../ui/content/Content.vue';
import { Header } from '~/widgets/header/';
import { Footer } from '~/widgets/footer/';
import { CookieBanner } from '~/widgets/cookie-banner';

onErrorCaptured((error, instance, info) => {
  console.error('Error captured:', error);
  console.error('Component instance:', instance);
  console.error('Error info:', info);
});

const isNeedChangeTab = ref(false);
provide('isNeedChangeTab', isNeedChangeTab);
</script>

<template>
  <Wrapper>
    <Header />
    <Content :class="$style.content">
      <div :class="$style.inside">
        <slot />
      </div>
    </Content>
    <Footer />
    <CookieBanner />
  </Wrapper>
</template>

<style module lang="scss">
.inside {
  height: 100%;
}

@media (min-width: 1024px) {
  .content > *:first-child {
    display: none;
  }
}

@media (max-width: 1023px) {
  .inside {
    border-right: none;
  }
}
</style>
